<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Customers</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm()"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Customer
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Customer
              </h4>
            </div>
          </div>
        </header>
        <!-- <div class="modal-body">
          <form @submit.prevent="getList()" method="post">
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group" style="padding-top: 25px;">
                  <button type="submit" class="btn btn-success">
                    &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                  </button>
                  <a href="" class="btn btn-danger"
                    >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                  >
                </div>
              </div>
            </div>
          </form>
        </div> -->
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Customer
          </h4>
        </template>
        <template #body>
          <AddCustomer
            :customerId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  CUSTOMER LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Customer Name</th>
                        <th width="10%">Address</th>
                        <th width="10%">Phone</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in itemList"
                        :key="item.customer_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ item.customer_name }}</td>
                        <td>
                          {{ item.customer_address }}</td>
                        <td>
                          {{ item.customer_phone }}</td>
                        <td>
                          <a
                            v-on:click="showForm(item.customer_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddCustomer from "../components/AddCustomer.vue";
import PanelModal from "../components/PanelModal.vue";

export default {
  name: "Customer",

  components: {
    AddCustomer,
    PanelModal,
  },
  data() {
    return {
      showFormModal: false,
      itemList: [],
      itemId: "",
      StatusActive: true,
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_customers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.customerList;
          }
        });
    },
    showForm: function(customerid) {
      this.itemId = customerid;
      this.showFormModal = true;
    },
  },
  mounted(){
    this.getList()
  }
};
</script>
